import axios from 'axios';

export const Result = {
  IN_PROGRESS: 'in_progress',
  SUCCESS: 'success',
  FAIL: 'fail',
};

export const registerLog = async (payload, options = { addParamsToQuery: false }) => {
  const { addParamsToQuery } = options;

  try {
    await axios.post('/logs', payload, { params: addParamsToQuery ? payload.params : {} });
  } catch (error) {
    console.error(JSON.stringify(error));
  }
};
